import api from './api';

export interface SumasYSaldosSearchParams {
  fechaDesde: string;
  fechaHasta: string;
}

export type SumasYSaldosLineaTipo = 'rubro' | 'saldoInicial' | 'cuenta';

export interface SumasYSaldosLinea {
  tipo: SumasYSaldosLineaTipo;
  nroRubro: number | null;
  nroCuenta: number | null;
  descripcion: string;
  debe: number;
  haber: number;
  saldoDeudor: number;
  saldoAcreedor: number;
  nivel: number;
}

export interface SumasYSaldosResult {
  fechaDesde: string;
  fechaHasta: string;
  lineas: SumasYSaldosLinea[];
  totalDebe: number;
  totalHaber: number;
  totalSaldoDeudor: number;
  totalSaldoAcreedor: number;
}

function unwrapMessage(error: unknown): string {
  const ax = error as { response?: { data?: { message?: string } }; message?: string };
  const m = ax.response?.data?.message ?? ax.message;
  return typeof m === 'string' && m.trim() ? m : 'Error en la operación';
}

async function getResult(path: string, params: SumasYSaldosSearchParams): Promise<SumasYSaldosResult> {
  const response = await api.get<SumasYSaldosResult>(path, {
    params: {
      fechaDesde: params.fechaDesde,
      fechaHasta: params.fechaHasta,
    },
  });
  return response.data;
}

const sumasYSaldosService = {
  get: async (params: SumasYSaldosSearchParams): Promise<SumasYSaldosResult> =>
    getResult('/api/SumasYSaldos', params),

  getExportData: async (params: SumasYSaldosSearchParams): Promise<SumasYSaldosResult> =>
    getResult('/api/SumasYSaldos/export-data', params),

  getPreviewPdfBlob: async (params: SumasYSaldosSearchParams): Promise<Blob> => {
    try {
      const response = await api.get<Blob>('/api/SumasYSaldos/preview-pdf', {
        params: {
          fechaDesde: params.fechaDesde,
          fechaHasta: params.fechaHasta,
        },
        responseType: 'blob',
      });
      return response.data;
    } catch (err: unknown) {
      throw new Error(unwrapMessage(err));
    }
  },

  parseError: unwrapMessage,
};

export default sumasYSaldosService;
